// Constants
import { GIL_RISK_ERROR_CODE } from 'utils/constants/resolver.utils.constants';
import { ERROR, ERROR_VERIFY } from '../../constants/contract-otp.constants';
// Types
import { HttpErrorResponseInterface } from '@openbank/ziniaweb-ui-core-models';
// Utils
import { businessPreconditionFailedFound } from '@openbank/cf-ui-framework';
import { isGilRiskError } from 'utils/resolver.utils';

const getVerifyOtpError = ({
  errorCode,
  status,
}: Pick<HttpErrorResponseInterface, 'errorCode'> & Pick<Response, 'status'>): string => {
  switch (true) {
    case isGilRiskError(errorCode):
      return GIL_RISK_ERROR_CODE;
    case businessPreconditionFailedFound(status) && !isGilRiskError(errorCode):
      return ERROR_VERIFY;
    default:
      return ERROR;
  }
};

export { getVerifyOtpError };
